module.exports = __webpack_public_path__ + "media/images/mobile-view-1024-45bb5eb15c00445fc054ff2948963776.svg";